import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProjectList } from "../../services/projectManagementService";

export const getProjects = createAsyncThunk(
  "get/projects/list",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getProjectList(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
